import { backend, RequestAttachment } from '@closer/api'
import { DeepPartial, OpportunityTimeline, R } from '@closer/types'

export const api = {
    createTimeline: (data: DeepPartial<OpportunityTimeline>, attachment?: RequestAttachment) => {
        return backend.post<OpportunityTimeline>(R.OPPORTUNITY_TIMELINES, data, attachment, 'v2')
    }
}
